<template>
    <v-container fluid > 
        <v-layout row wrap>
            <v-form>
                <h4>{{$t('labels.speciesData')}}</h4>
                <SelectTaxonomy v-model="newSpeciesData"></SelectTaxonomy>
                {{ newSpeciesData.genus }}
                <v-text-field
                    v-model="speciesName"
                    :counter="50"
                    style="max-width:250px;"
                    :label="$t('labels.specificEpithet')"
                    required
                ></v-text-field>
            </v-form>
        </v-layout>
        <v-btn
            dark
            absolute
            bottom
            right
            fab
            color="green"
            style="bottom:20px;"
            @click.native="createSpecies()"
            > <v-icon style="font-size:40px;padding-top:5px;">check</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
const axios = require('axios').default;
import SelectTaxonomy from '@/partial/SelectTaxonomy.vue'
export default {
    name: 'SpeciesAdd',
    components: {
        SelectTaxonomy
    },
    data: function(){
        return{
            newSpeciesData:{
                "order":null,
                "suborder": null,
                "family":null,
                "genus":null
            },
            speciesName: null
        };
    },
    mounted: function(){
        let vm = this;
    },
    methods:{
        createSpecies() {
            let vm = this;
            axios({
                method: "POST",
                url: vm.$API_BASE_URL + "species/create.php",
                data: {
                    "order": vm.newSpeciesData.order,
                    "suborder": vm.newSpeciesData.suborder,
                    "family": vm.newSpeciesData.family,
                    "genus": vm.newSpeciesData.genus,
                    "species": vm.speciesName
                },
                headers: {
                    'Authentication-Token': window.localStorage.getItem("herp_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.$router.push({name: 'speciesSingle', params:{speciesId:response.data.id}});
                } 
                else{
                    alert(vm.$t('labels.errorLoading'));
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert(vm.$t('labels.errorLoading'));
                    console.error(error)
                }
            });
        }
    }
}
</script>

